import { VisitCategoriesApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const visitCategoriesApi = new VisitCategoriesApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
